// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3la72","unreadBadge":"styles_unreadBadge__268bv","modalContent":"styles_modalContent__ZOnm_","modal":"styles_modal__3FhQM"};